export default {
  getSession() {
    return document.cookie.replace(/(?:(?:^|.*;\s*)MOSSID\s*=\s*([^;]*).*$)|^.*$/, '$1');
  },

  isAuthenticated() {
    return !!this.getSession();
  },
};
